function Nav() {
  return (
    <div className="w-full h-24 md:h-28 bg-white flex flex-col items-center border-b border-gray-100 shadow">
      <div className="h-full w-11/12 md:w-8/12 flex flex-row items-center justify-center sm:justify-start">
        <img src="wdc-logo.png" alt="Tauranga City Council logo" className="h-9 md:h-12" />
      </div>
    </div>
  );
};

export default Nav;
